import { defineStore } from "pinia";
import { computed, ref } from "vue";
import PriceModelCurveDO = Modules.BookingExperts.Data.PriceModelCurve.PriceModelCurveDO;
import PeriodSelectionDTO = App.Data.Explorer.PeriodSelectionDTO;
import MasterPriceDO = Modules.BookingExperts.Data.MasterPriceList.MasterPriceDO;
import PriceModelCurveBaseDataDTO = Modules.BookingExperts.Data.PriceModelCurve.PriceModelCurveBaseDataDTO;

type CurveMovementDirection = "horizontal" | "vertical" | "individual";

export interface CurrentCurveOccupancy {
	occupancy: number;
	bookedOccupancy: number;
	leadDay: number;
}

/** Store for the current price model */
export const useCurveModelStore = defineStore("curveModelStore", () => {
	/** Show previous year data */
	const showPY = ref(false);
	/** Show current year data */
	const showCY = ref(false);
	/** The currently selected curve */
	const currentCurve = ref<PriceModelCurveDO>();
	/** The movement direction option used to move all points in the curve at once */
	const moveDirection = ref<CurveMovementDirection>("individual");
	/** The period selected to display the reference data for */
	const periodSelection = ref<PeriodSelectionDTO>();
	/** TODO: No clue yet*/
	const priceLists = ref<MasterPriceDO[]>([]);
	/** CY and PY Reference data */
	const referenceData = ref<PriceModelCurveBaseDataDTO>({ y0: [], y1: [] });
	/** Scale the baseDate curve from the currentCurve to this desired occupancy */
	const targetPercentage = ref(100);
	/** If set, we can observe the current occupancy in the graph */
	const currentOccupancy = ref<CurrentCurveOccupancy | null>(null);

	const sourcePriceLists = computed(() => {
		return priceLists.value.filter((p) => p.is_source);
	});

	const currentBreadcrumb = ref<string | null>(null);

	return {
		showCY,
		showPY,
		currentCurve,
		moveDirection,
		referenceData,
		periodSelection,
		priceLists,
		targetPercentage,
		currentOccupancy,
		sourcePriceLists,
		currentBreadcrumb,
	};
});

/** Store around the chart itself. */
export const useCurveModelChartStore = defineStore(
	"curveModelChartStore",
	() => {
		const highlightedPositiveIndex = ref<number | null>(null);
		const highlightedNegativeIndex = ref<number | null>(null);

		return {
			highlightedPositiveIndex,
			highlightedNegativeIndex,
		};
	}
);
